import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, { Assinatura, Botao as BotaoForm } from 'Component/Form';
import Imagem from 'Component/Imagem';
import Emprestimo from 'Interface/EmprestimosEpi';
import { useEditarEmprestimoUniformeMutation, useRecuperarEmprestimoUniformeQuery } from 'View/Service/Default/EmprestimosUniforme';

const regras = object({
  assinatura: string().required('Obrigatório'),
});

const Assinar = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const toast = useToast();
  const navegacao = useNavigate();

  const [editarEmprestimoUniforme] = useEditarEmprestimoUniformeMutation();

  const { data: { emprestimo } = {} } = useRecuperarEmprestimoUniformeQuery(id);

  const enviar = async (dados: Emprestimo): Promise<void> => {
    try {
      await editarEmprestimoUniforme({
        ...dados,
        assinatura: dados.assinatura,
      }).unwrap();

      toast({
        tema: 'success',
        conteudo: 'Assinado com sucesso',
      });

      navegacao('/emprestimos-uniforme/historico');
    } catch (erro) {
      toast({
        tema: 'danger',
        titulo: 'Erro ao assinar',
        conteudo: 'Verifique os logs para mais informações',
      });
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center py-5">
        <div className="col-md-5">
          <h1 className="text-center">Assinar emprestimo de uniforme</h1>
          <p className="text-center">
            Faça sua assinatura no campo abaixo para assinar seu emprestimo.
          </p>
          <Form
            onSubmit={enviar}
            regras={regras}
            inicial={emprestimo}
            desabilitado={!!emprestimo?.assinatura}
          >
            {emprestimo?.assinatura ? (
              <Imagem src={emprestimo.assinatura} className="img-fluid" />
            ) : (
              <Assinatura name="assinatura" rotulo="Assinatura" />
            )}
            <div className="text-center">
              <BotaoForm>Assinar</BotaoForm>{' '}
            </div>
          </Form>
          <div className="text-center mt-3">
            <BotaoLink to="/emprestimos-uniforme/historico" tema="light">
              Cancelar
            </BotaoLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assinar;
